import "./App.css";
import "./Style.css";
import "./Style2.css";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./Pages/Home";
import AccountSummary from "./Pages/MyAccount/AccountSummary";
import { getDecodedToken } from "./Utils/Constant";
import Login from "./Pages/Login";
import BetList from "./Pages/BetList";
import BetListLive from "./Pages/BetListLive";
import Banking from "./Pages/Banking/Banking";
import ActivityLogs from "./Pages/MyAccount/ActivityLogs";
import Profile from "./Pages/MyAccount/Profile";
import AccountStatement from "./Pages/MyAccount/AccountStatement";
import AllUser from "./Pages/AllUser";
import ReportByDownline from "./Pages/Report/ReportByDownline";
import { AuthProvider } from "./context/AuthContext";
import BlockMarket from "./Pages/BlockMarket";
import ReportByEvent from "./Pages/Report/ReportByEvent";
import ReportByParlayDownline from "./Pages/Report/ReportByParlayDownline";
import ReportByMarket from "./Pages/Report/ReportByMarket";
import ReportByPlayer from "./Pages/Report/ReportByPlayer";
import ReportByCasinoDownline from "./Pages/Report/ReportByCasinoDownline";
import ReaportByAllCasino from "./Pages/Report/ReaportByAllCasino";
import ReportByAWCcasino from "./Pages/Report/ReportByAWCcasino";
import Risk from "./Pages/RiskManagement/Risk";
import SportAnalytics from "./Pages/SportAnalytics/SportAnalytics";
import ParlayBetList from "./Pages/RiskManagement/ParlayBetList";
import CasinoBetList from "./Pages/CasinoBetList";
import BoCasinoBets from "./Pages/BoCasinoBets";
import Ticket from "./Pages/Ticket";
import BankingLogs from "./Pages/Banking/BankingLogs";
import CurrentBets from "./Pages/MyAccount/CurrentBets";
import BettingHistory from "./Pages/MyAccount/BettingHistory";
import BettingProfitLoss from "./Pages/MyAccount/BettingProfitLoss";
import TransactionHistory from "./Pages/MyAccount/TransactionHistory";
import CasinoProfitLoss from "./Pages/MyAccount/CasinoProfitLoss";
import ParlayBetHistory from "./Pages/MyAccount/ParlayBetHistory";
import BoCasinoBetHistory from "./Pages/MyAccount/BoCasinoBetHistory";
import BoCasinoProfitLoss from "./Pages/MyAccount/BoCasinoProfitLoss";
import AWCcasinoBetHistory from "./Pages/MyAccount/AWCcasinoBetHistory";
import AWCcasinoProfitLoss from "./Pages/MyAccount/AWCcasinoProfitLoss";
import ReportByBoCasino from "./Pages/Report/ReportByBoCasino";
import MM from "./Pages/MM";
import MobileLogin from "./Pages/MobileLogin";
import { isMobile } from "react-device-detect";
import Setting from "./Pages/Setting";
import SportSetting from "./Pages/User/SportSetting";
import RootRedirect from "./components/RootRedirect";
import Links from "./Pages/Link/Link";
import Banner from "./Pages/Banner/Banner";
import ChangePassword from "./Pages/ChangePassword";
import SearchUser from "./Pages/SearchUser";
import ActiveSpinReport from "./Pages/Report/ActiveSpinReport";
import SpinReport from "./Pages/Report/SpinReport";
const getAuthorizedRoutes = () => {
  const user = getDecodedToken();
  return routes.filter(
    (item) =>
      !item.permission?.length || item.permission.includes(user?.userType),
  );
};

function App() {
  // useEffect(() => {
  //   const loginMsg = sessionStorage.getItem("loginSuccessMsg");
  //   if (loginMsg !== null) {
  //     sessionStorage.removeItem("loginSuccessMsg");
  //     if (loginMsg) toast.success(loginMsg);
  //   }
  // }, []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login" element={isMobile ? <MobileLogin /> : <Login />} />
        <Route path="/change-password" element={<ChangePassword/>} />

        <Route element={<PrivateRoute />}>
          {getAuthorizedRoutes().map(({ path, Component }, index) => (
            <Route key={index} path={path} element={<Component />} />
          ))}
        </Route>
      </>,
    ),
  );

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
const routes = [
  { path: "/", Component: RootRedirect, permission: [] },
  { path: "/users/:layer/*", Component: Home, permission: [] },
  { path: "/alluser", Component: AllUser, permission: [] },
  { path: "/banking", Component: Banking, permission: [] },
  { path: "/betList", Component: BetList, permission: [] },
  { path: "/betList-live", Component: BetListLive, permission: [] },
  {
    path: "/setting",
    Component: Setting,
    permission: ["sub_owner", "super_admin", "owner", "admin"],
  },

  {
    path: "/my-account/account-summary/:id?/:type?",
    Component: AccountSummary,
    permission: [],
  },
  {
    path: "/website-setting",
    Component: SportSetting,
    permission: [],
  },
  {
    path: "/my-account/login-history/:id?/:type?",
    Component: ActivityLogs,
    permission: [],
  },  {
    path: "/ActiveSpinReport",
    Component: ActiveSpinReport,
    permission: ["sub_owner", "super_admin", "agent", "admin"],
  },
  {
    path: "/SpinReport",
    Component: SpinReport,
    permission: ["sub_owner", "super_admin", "agent", "admin"],
  },
  {
    path: "/my-account/profile/:id?/:type?",
    Component: Profile,
    permission: [],
  },
  {
    path: "/my-account/account-statement/:id?/:type?",
    Component: AccountStatement,
    permission: [],
  },
  {
    path: "/my-account/current-bets/:id?/:type?",
    Component: CurrentBets,
    permission: [],
  },
  {
    path: "/my-account/betting-history/:id?/:type?",
    Component: BettingHistory,
    permission: [],
  },
  {
    path: "/banking/bankinglog/:id?",
    Component: BankingLogs,
    permission: [],
  },
  {
    path: "/my-account/profit-loss/:id?/:type?",
    Component: BettingProfitLoss,
    permission: [],
  },
  {
    path: "/my-account/transaction-history/:id?/:type?",
    Component: TransactionHistory,
    permission: [],
  },

  {
    path: "/my-account/allcasnio-pnl/:id?/:type?",
    Component: CasinoProfitLoss,
    permission: [],
  },

  {
    path: "/my-account/parlay-bethistory/:id?/:type?",
    Component: ParlayBetHistory,
    permission: [],
  },
  {
    path: "/my-account/bogcasino-bethistory/:id?/:type?",
    Component: BoCasinoBetHistory,
    permission: [],
  },
  {
    path: "/my-account/bogcasino-profitloss/:id?/:type?",
    Component: BoCasinoProfitLoss,
    permission: [],
  },

  {
    path: "/my-account/awccasino-bethistory/:id?/:type?",
    Component: AWCcasinoBetHistory,
    permission: [],
  },
  {
    path: "/my-account/awccasino-profitloss/:id?/:type?",
    Component: AWCcasinoProfitLoss,
    permission: [],
  },

  {
    path: "/reports/pl-downline/:id?/:user_type?",
    Component: ReportByDownline,
    permission: [],
  },
  {
    path: "/reports/pl-market",
    Component: ReportByEvent,
    permission: [],
  },
  {
    path: "/reports/parlay-Downline",
    Component: ReportByParlayDownline,
    permission: [],
  },
  {
    path: "/reports/pnl-match",
    Component: ReportByMarket,
    permission: [],
  },
  {
    path: "/reports/pl-player",
    Component: ReportByPlayer,
    permission: [],
  },
  {
    path: "/reports/pnl-casino-downline/:id?/:type?",
    Component: ReportByCasinoDownline,
    permission: [],
  },
  {
    path: "/reports/pnl-downline",
    Component: ReaportByAllCasino,
    permission: [],
  },
  {
    path: "/reports/pl-awccasino",
    Component: ReportByAWCcasino,
    permission: [],
  },
  {
    path: "/reports/pl-bogcasino",
    Component: ReportByBoCasino,
    permission: [],
  },
  {
    path: "/risk-management/riskManagement",
    Component: Risk,
    permission: [],
  },
  {
    path: "/match-details/:eventId/:marketId",
    Component: SportAnalytics,
    permission: [],
  },

  {
    path: "/parlaybetlist",
    Component: ParlayBetList,
    permission: [],
  },
  {
    path: "/awcCasino",
    Component: CasinoBetList,
    permission: [],
  },
  {
    path: "/bogCasino",
    Component: BoCasinoBets,
    permission: [],
  },
  {
    path: "/messages/ticker",
    Component: Ticket,
    permission: [],
  },
  {
    path: "/events",
    Component: MM,
    permission: ["sub_owner", "super_admin", "owner", "admin"],
  },
  {
    path: "/block-market",
    Component: BlockMarket,
    permission: [],
  },
  {
    path: "/banner",
    Component: Banner,
    permission: ["sub_owner", "super_admin", "owner", "admin"],
  },
  {
    path: "/manage-links",
    Component: Links,
    permission: ["owner", "sub_owner"],
  },
  {
    path: "/searchuser",
    Component: SearchUser,
    permission: ["owner", "sub_owner"], //"owner", "super_admin"
  },
];
